import React from "react";
import TrustedBy from "components/collection-details/trustedby";
const TrustedByBlock = () => {
    return (
        <div className="trusted-by-block container">
            <div className="trusted-by-block__inner">
                <TrustedBy />
            </div>

        </div>
    );
};

export default TrustedByBlock;